<div class="title-content">
	<span translate>qty-by-family.title.note</span>
</div>
<div [formGroup]="formFamilyByVolumeGroup">
	<div class="content" formArrayName="formFamilyByVolumes">
		<div class="quantity-input-group" *ngFor="let familByVolume of pcpSplit; let i = index" [formGroupName]="i">
			<div *ngIf="!isReadOnly">
				<mat-form-field class="form-field-qty" [hideRequiredMarker]="true">
					<mat-label class="copo-grid-row">{{getDisplayLabel(familByVolume)}}</mat-label>
					<input formControlName="quantity" matInput
						copoInputNumber
						autocomplete="off"
						type="number"
						[formControl]="getFormControlebyIndex(i)"
						[decimalCount]="0"
						[min]="1"
						[max]="99_999_999.99"
						(change)="calculateTotalQuantity()"/>
						<mat-icon color="accent" class="pencil-icon-size" svgIcon="copo_pencil" matSuffix></mat-icon>
						<mat-error *ngIf="isError" class="copo-hint-warning wrap-error">
							<span translate>eoffer.mandatory.quantity</span>!
						</mat-error>
				</mat-form-field>
			</div>
			<div *ngIf="isReadOnly" class="card-content-info">
				<div class="card-content-label">{{getDisplayLabel(familByVolume)}}</div>
				<div class="card-content-value">
					{{ getQuantityIndex(i) }}
				</div>
			</div>
		</div>
	</div>
</div>